/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var DepProgressReportNewView = require('../views/DepProgressReportNewView');

var GetAllEnforcementLookups = require('../services/GetAllEnforcementLookups');
var GetEnforcementIdentifiers = require('../services/GetEnforcementIdentifiers');

module.exports = function(entityId, enforcementId) {
  NProgress.start();
  NProgress.set(0.6);
  GetEnforcementIdentifiers(enforcementId)
    .done(function(enforcementIdentifiers) {
      GetAllEnforcementLookups(enforcementIdentifiers.categoryId)
        .done(function(enforcementLookups) {
          NavUtils.navigate('dep/entity/' + entityId + '/enforcement/' + enforcementId + '/new-progress-report');
          Scaffold.content.show(
            new DepProgressReportNewView({
              viewMode: 'int',
              model: new Backbone.Model({
                entityId: entityId,
                enforcementId: enforcementId,
                enforcementIdentifiers: enforcementIdentifiers,
                quarters: enforcementLookups.quarters,
                progressReportStatuses: enforcementLookups.progressReportStatuses,
                reportYears: enforcementLookups.progressReportYears
              })
            })
          );
          NProgress.done();
        })
        .fail(function(err) {
          NProgress.done();
        });
    })
    .fail(function(err) {
      NProgress.done();
    });
};
